// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// Ajax library
import axios from 'axios'

import '@fortawesome/fontawesome-free-webfonts/css/fontawesome.css'

// Vue
import Vue from 'vue'
import Vuex from 'vuex'
import VueAxios from 'vue-axios'

// Application router
import router from './router'

// other utils
import print from 'vue-print-nb'

// 自定义的工具函数
import utils from './utils'

window.xutil = utils;

// Vuetify components
import {
  transitions,
  VAlert,
  VCombobox,
  VApp,
  VBtn,
  VCard,
  VDataTable,
  VDatePicker,
  VDialog,
  VDivider,
  VFooter,
  VForm,
  VGrid,
  VIcon,
  VList,
  VMenu,
  VNavigationDrawer,
  VProgressLinear,
  VSelect,
  VSnackbar,
  VTextField,
  VToolbar,
  VTooltip,
  VTabs,
  VCheckbox,
  VSwitch,
  VChip,
  VDataIterator,
  VBtnToggle,
  VSubheader,
  VAvatar,
  VBreadcrumbs,
  VStepper,
  VRadioGroup,
  VJumbotron,
  VAutocomplete,
  VTextarea,
  VTreeview,
  VTimeline,
  Vuetify
} from 'vuetify'


import '../node_modules/vuetify/src/stylus/app.styl'

import App from './App'

// Translation provided by Vuetify (javascript)
import zhHans from 'vuetify/es5/locale/zh-Hans'

Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.use(print);

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VDataTable,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    VTooltip,
    VCard,
    VTextField,
    VAlert,
    VDialog,
    VDivider,
    VSelect,
    VProgressLinear,
    VForm,
    VMenu,
    VDatePicker,
    VSnackbar,
    VTabs,
    VCheckbox,
    VSwitch,
    VChip,
    VDataIterator,
    VBtnToggle,
    VSubheader,
    VAvatar,
    VBreadcrumbs,
    VStepper,
    VRadioGroup,
    VJumbotron,
    VAutocomplete,
    VTextarea,
    VTreeview,
    transitions,
    VCombobox,
    VTimeline
  },
  lang: {
    locales: {zhHans},
    current: 'zhHans'
  }
});


Array.prototype.clone = function () {
  return this.slice(0);
};

Array.prototype.unique = function (mutate) {
  const unique = this.reduce(function (accum, current) {
    if (accum.indexOf(current) < 0) {
      accum.push(current);
    }
    return accum;
  }, []);
  if (mutate) {
    this.length = 0;
    for (let i = 0; i < unique.length; ++i) {
      this.push(unique[i]);
    }
    return this;
  }
  return unique;
};

Vue.config.productionTip = false;

import VueXStore from './store'

const store = VueXStore.getStore();

/**
 * 人民币金额格式化
 */
Vue.filter('currency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('zh-Hans-CN', {
    style: 'currency',
    currency: 'CNY',
    minimumFractionDigits: 2
  });
  return formatter.format(value);
});

/**
 * 格式化时间戳
 */
Vue.filter('timestamp', function (value) {
  return value && value.slice(0, -5).replace('T', ' ')
});

Vue.filter('datetime', function (value) {
  return value && value.slice(0, -8).replace('T', ' ')
});

/**
 * 格式化文件大小
 */
Vue.filter('fileSize', function (size) {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB'
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB'
  }
  return size.toString() + ' B'
});

/**
 * 格式化百分比
 */
Vue.filter('percent', function (value) {
  const v = Math.round(Number(value) * 100, 2) / 100;
  return v.toString() + '%';
});

// 请求拦截器, 附加用户、角色信息
Vue.axios.interceptors.request.use(
  function (config) {
    // 如果用户已经登录，则在请求中生成 X-AUTH-TOKEN 头信息
    if (store.getters.userId) {
      //console.log(" in Vue.axios.interceptors.request");
      config.headers['X-AUTH-TOKEN'] =
        xutil.token(
          config.method,
          config.url.split('?')[0], // 只要请求路径
          config.data ? JSON.stringify(config.data).length : 0,
          store.getters.username,
          store.getters.password,
          store.getters.deptId,
          store.getters.roleId
        );
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// 直接输入地址时的，登录拦截器，在未登录时跳转登录页面
router.beforeEach(
  (to, from, next) => {
    //console.log("in $router.beforeEach");

    if (to.meta.public === true) {
      next();
      return;
    }

    if (to.matched.some(record => record.meta.public !== true)) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!store.getters.userId) {
        next({
          path: '/login',
          query: {redirect: to.fullPath}
        })
      } else {
        const menus = store.getters.menus;
        if (menus) {
          if (menus.find(v => v === to.path.split("?", 2)[0])) {
            next()
          } else {
            next({name: '_403'})
          }
        } else {
          next()
        }
      }
    } else {
      next() // 确保一定要调用 next()
    }
  });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App />'
});



// WEBPACK FOOTER //
// ./src/main.js